import { Gender, GendersCollection } from '@app/interfaces';

export function removeNullValuesFromGendersCollection(genderCollection: GendersCollection): GendersCollection {
    return genderCollection?.filter((gender: Gender) => gender.value != null);
}
